/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainOrganisationStatus = 'Pending' | 'Active' | 'Inactive';

export const DomainOrganisationStatus = {
    Pending: 'Pending' as DomainOrganisationStatus,
    Active: 'Active' as DomainOrganisationStatus,
    Inactive: 'Inactive' as DomainOrganisationStatus
};